import { useFlag } from '@acre/utils'

// The brand half of the tab title. A standalone brand label, so it keeps the logo full
// stop — unlike useBrandName below, which lands in running copy.
export const useBrandedTitle = () => {
  const isScoreRebrand = useFlag('feature.score_rebrand', false)

  return isScoreRebrand ? 'Score. Broker CRM' : 'Acre Broker CRM'
}

// Single source for the Helmet titleTemplate so every page-level Helmet
// switches brand with the rebrand flag together with the app shell's template.
export const useBrandedTitleTemplate = () => {
  const brandedTitle = useBrandedTitle()

  return `${brandedTitle} | %s`
}

// Brand name for hardcoded (non-i18n) copy that references the product by name.
// Every consumer drops it into running copy or a filename, so it takes no logo
// full stop — unlike the tab title above, which is a standalone brand label.
export const useBrandName = () => {
  const isScoreRebrand = useFlag('feature.score_rebrand', false)

  return isScoreRebrand ? 'Score' : 'Acre'
}
